import Card from '$app/components/vendor/Card';
import styled from 'styled-components';
import Title from '../../../components/Title';

export default styled(Card)`
  margin: 20px 0 0 0;
`;

export const NoteTitle = styled(Title)``;
